<template>
	<div class="drawer">
		<el-drawer
		size="433px"
		title="宠物信息"
		:visible.sync="drawerStatus"
		:modal-append-to-body="false"
		:close-on-click-modal="false"
		@close='close'
		>
			<el-form style="padding:10px 36px 0 0px;">
				<el-form-item label="昵称：" :label-width="formLabelWidth" required>
					<el-input v-model="form.nick_name" autocomplete="off" placeholder="请输入宠物昵称" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="种类：" :label-width="formLabelWidth" required>
					<el-radio-group v-model="form.pet_type" @change="typeChange" size="mini">
						<el-radio :label="'2'">犬</el-radio>
						<el-radio :label="'1'">猫</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="品种：" :label-width="formLabelWidth" required>
					<el-select class="select" style="width:300px;" filterable default-first-option v-model="form.category_id" placeholder="请选择品种" size="mini">
						<el-option v-for="item in typeList" :key="item.id" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="类型：" :label-width="formLabelWidth">
					<el-radio-group v-model="form.pet_varieties">
						<el-radio v-if="form.pet_type==='2'" :label="'11'">普通犬</el-radio>
						<el-radio v-if="form.pet_type==='2'" :label="'12'">特种犬</el-radio>
						<el-radio v-if="form.pet_type==='1'" :label="'21'">普通猫</el-radio>
						<el-radio v-if="form.pet_type==='1'" :label="'22'">特种猫</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="毛发：" :label-width="formLabelWidth">
					<el-radio-group v-model="form.pet_features">
						<el-radio :label="'1'">短毛</el-radio>
						<el-radio :label="'2'">长毛</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="毛色：" :label-width="formLabelWidth">
					<!-- allow-create -->
					<el-select class="select" style="width:300px;" filterable default-first-option v-model="form.pet_color" placeholder="请选择毛色" size="mini">
						<el-option v-for="item in colorList" :key="item._id" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="性别：" :label-width="formLabelWidth" required>
					<el-radio-group v-model="form.pet_sex" size="mini">
						<el-radio :label="'公'">公</el-radio>
						<el-radio :label="'母'">母</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="用品编号：" :label-width="formLabelWidth">
					<el-input v-model="form.tool_num" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="出生日期：" :label-width="formLabelWidth">
					<el-date-picker style="width:300px;" v-model="form.bron_date" @change="changeDatePicker" :picker-options="{disabledDate(time) {return new Date().getTime() < time.getTime()}}" type="date" placeholder="选择日期" size="mini">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="年龄：" :label-width="formLabelWidth">
					<div style="padding-top:6px;">
						<el-input v-model="curPetYear" @input="inputPetYear" style="width:104px;" size="mini">
							<template slot="append">年</template>
						</el-input>
						<el-input v-model="curPetMonth" @input="inputPetMonth" style="width:104px" size="mini">
							<template slot="append">月</template>
						</el-input>
					</div>
				</el-form-item>
				<el-form-item label="芯片编号：" :label-width="formLabelWidth">
					<el-input v-model="form.eprom_no" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="性格：" :label-width="formLabelWidth">
					<el-checkbox-group v-model="characters">
						<el-checkbox v-for="character in characterList" :label="character" :key="character">{{character}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="其他：" :label-width="formLabelWidth">
					<el-checkbox-group v-model="checkList" size="mini">
						<el-checkbox label="已绝育"></el-checkbox>
						<el-checkbox label="已免疫"></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="体重：" :label-width="formLabelWidth">
					<el-input autocomplete="off" v-model="form.weight" @input="changeWeight" clearable size="mini">
						<template slot="append">kg</template>
					</el-input>
				</el-form-item>
				<el-form-item label="体重说明：" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="form.weight_remark" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
				<el-form-item label="宠物状态：" :label-width="formLabelWidth">
					<el-radio-group v-model="form.status" size="mini">
						<el-radio :label="'1'">正常</el-radio>
						<el-radio :label="'3'">丢失</el-radio>
						<el-radio :label="'4'">亡故</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- <el-form-item label="花生宠物：" :label-width="formLabelWidth">
					<el-radio-group v-model="form.hs_pet" size="mini">
						<el-radio :label="true">是</el-radio>
						<el-radio :label="false">否</el-radio>
					</el-radio-group>
				</el-form-item> -->
				<el-form-item label="备注：" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="form.remark" autocomplete="off" clearable size="mini"></el-input>
				</el-form-item>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				title:'',
				formLabelWidth: '100px',
				// 性格
				characters:[],
				characterList:['安静', '温顺', '暴躁', '活泼', '对陌生人不友善'],
				
				form: {
					"member_id": "",
					"_id": "",
					"status": "", // 状态 1正常；2删除；3丢失；4亡故
					"nick_name": "",  
					"eprom_no": "",  // 芯片号
					"pet_type": "",  
					"category_id": "",  
					"category_name": "",  
					"pet_features": "",  // 0: 不限制 1:短毛 2:长毛
					"pet_varieties": "",  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
					"pet_certificate_no": "",  // 宠物证件编号
					"character": "",  // 性格
					"pet_sex": "",  
					"pet_color": "",  
					"remark": "",  
					"hs_pet": true,  // 是否花生宠物
					"sterilization": 0,  // 绝育
					"immunization": 0,  // 免疫
					"bron_date": "",  // 生日
					"home_date": "",  // 到家时间
					"avatar_pic": "",  // 缩略图
					"tool_num": "",  // 用具编号
					"weight": 0, 
					"weight_remark": "",  
				},
				typeList:[],
				typeList1:[],
				typeList2:[],
				colorList:[],
				curPetYear:0,
				curPetMonth:0,
				checkList: [],
			}
		},
		computed:{
		},
		props:{
			dialog_type:{
				default:'addPet'
			},
			userInfo:{
				default:()=>{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						vip_grades:{}
					}
				}
			},
			petInfo:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			// curPetYear(n){
			// 	if(!n){
			// 		n=0
			// 	}
			// 	let month = parseInt(Number(n)*12+Number(this.curPetMonth));
			// 	this.form.bron_date = this.$public.FBirthday(month)
			// },
			// curPetMonth(n){
			// 	if(!n){
			// 		n=0
			// 	}
			// 	let month = parseInt(Number(this.curPetYear)*12+Number(n));
			// 	this.form.bron_date = this.$public.FBirthday(month)
			// },
		},
		mounted() {
			console.log(this.dialog_type)
			this.$nextTick(()=>{this.drawerStatus=true})
			if(this.dialog_type==="addPet"){
				this.title = "新增宠物"
				this.addPet();
			}else if(this.dialog_type==="editPet"){
				this.title = "编辑宠物"
				this.editPet()
			}else{
				this.title = this.dialog_type;
			}
			// 获取猫狗分类
			let params = {
				category: '活体'
			}
			this.$http.get(process.env.VUE_APP_business+'/api/Product/Category/Tree', params).then(res => {
				if(res.code===0){
					for(let i=0;i<res.data[0].children.length;i++){
						let item = res.data[0].children[i];
						if(item.id==='603f7255664b790a9c7d4f61'){
							this.typeList1 = item.children;
						}
						if(item.id==='603f7255664b790a9c7d4f62'){
							this.typeList2 = item.children;
						}
					}
					this.getTypeList()
				}
			})
			// 获取猫狗颜色
			this.getColorList();
		},
		methods: {
			close(){
				this.$emit('submit',{type:'close'})
			},
			// 修改日期
			changeDatePicker(val){
				let a = this.$public.FAge(val);
				this.form.birthday = this.$public.FTime(new Date(val).getTime().toString().substr(0,10),'YYYY-MM-DD');
				this.curPetYear = a[0];
				this.curPetMonth = a[1];
			},
			inputPetYear(){
				this.curPetYear = this.$public.FInt(this.curPetYear)
				this.curPetMonth = this.curPetMonth||0
				let month = parseInt(Number(this.curPetYear)*12+Number(this.curPetMonth));
				this.form.bron_date = this.$public.FBirthday(month)
			},
			inputPetMonth(){
				this.curPetMonth = this.$public.FInt(this.curPetMonth)
				this.curPetYear = this.curPetYear||0
				let month = parseInt(Number(this.curPetYear)*12+Number(this.curPetMonth));
				this.form.bron_date = this.$public.FBirthday(month)
			},
			// 切换猫狗
			typeChange(){
				this.getTypeList();
				this.form.category_id='';
			},
			// 获取毛色列表
			getColorList() {
				let params = {
					"keyword": "",
					"pageIndex": 1,
					"pageSize": 1000
				}
				this.$http.post(process.env.VUE_APP_business+'/api/DataCenter/List', params).then(res => {
					if (res.code == 0) {
						this.colorList = res.data.data;
					}
				})
			},
			// 获取品种列表
			getTypeList() {
				if(this.form.pet_type==='1'){
					this.typeList = this.typeList1;
				}else if(this.form.pet_type==='2'){
					this.typeList = this.typeList2;
				}
			},
			// 修改体重
			changeWeight(){
				this.form.weight = this.$public.replaceGoodsDosage(this.form.weight)
			},
			// 添加宠物
			addPet() {
				this.form = {
					"member_id": this.userInfo._id,
					"_id": "",
					"status": "1", // 状态 1正常；2删除；3丢失；4亡故
					"nick_name": "",  
					"eprom_no": "",  // 芯片号
					"pet_type": "2",  
					"category_id": "",  
					"category_name": "",  
					"pet_features": "",  // 0: 不限制 1:短毛 2:长毛
					"pet_varieties": "",  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
					"pet_certificate_no": "",  // 宠物证件编号
					"character": "",  // 性格
					"pet_sex": "公",  
					"pet_color": "",  
					"remark": "",  
					"hs_pet": false,  // 是否花生宠物
					"sterilization": 0,  // 绝育
					"immunization": 0,  // 免疫
					"bron_date": "",  // 生日
					"home_date": "",  // 到家时间
					"avatar_pic": "",  // 缩略图
					"tool_num": "",  // 用具编号
					"weight": 0, 
					"weight_remark": "",
				};
				this.curPetYear = 0;
				this.curPetMonth = 0;
				this.checkList = [];
				this.character = []
			},
			// 编辑宠物
			editPet() {
				this.form = {
					"member_id": this.userInfo._id,
					"_id": this.petInfo._id,
					"status": this.petInfo.status.value, // 状态 1正常；2删除；3丢失；4亡故
					"nick_name": this.petInfo.nick_name,
					"eprom_no": this.petInfo.eprom_no,  // 芯片号
					"pet_type": this.petInfo.apply_type.value,  
					"category_id": this.petInfo.category_info._id,  
					"category_name": this.petInfo.category_info.name,  
					"pet_features": this.petInfo.pet_features?this.petInfo.pet_features.value:'',  // 0: 不限制 1:短毛 2:长毛
					"pet_varieties": this.petInfo.pet_varieties?this.petInfo.pet_varieties.value:'',  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
					"pet_certificate_no": this.petInfo.pet_certificate_no,  // 宠物证件编号
					"character": '',  // 性格
					"pet_sex": this.petInfo.pet_sex,  
					"pet_color": this.petInfo.pet_color,  
					"remark": this.petInfo.remark,  
					"hs_pet": this.petInfo.hs_pet,  // 是否花生宠物
					"sterilization": this.petInfo.sterilization,  // 绝育
					"immunization": this.petInfo.immunization,  // 免疫
					"bron_date": this.petInfo.bron_date,  // 生日
					"home_date": this.petInfo.home_date,  // 到家时间
					"avatar_pic":this.petInfo.avatar_pic,  // 缩略图
					"tool_num": this.petInfo.tool_num,  // 用具编号
					"weight": this.petInfo.weight, 
					"weight_remark": this.petInfo.weight_remark,
				};
				this.curPetYear = this.$public.FAge(this.form.bron_date)[0];
				this.curPetMonth = this.$public.FAge(this.form.bron_date)[1];
				this.checkList = [];
				this.characters = this.$public.isNull(this.petInfo.character)?[]:this.petInfo.character.split(',');
				if (this.petInfo.sterilization == 1) {
					this.checkList.push("已绝育")
				}
				if (this.petInfo.immunization == 1) {
					this.checkList.push("已免疫")
				}
			},
			submit(){
				if(this.$public.isNull(this.form.nick_name)){
					this.$message({
						message: '请录入宠物昵称',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.form.category_id)){
					this.$message({
						message: '请选择宠物品种',
						type: 'error'
					});
					return ;
				}
				let category_name = '';
				if(this.form.pet_type==='1'){
					category_name = this.$public.getArrItemByKey(this.typeList1, 'id', this.form.category_id).label;
				}else if(this.form.pet_type==='2'){
					category_name = this.$public.getArrItemByKey(this.typeList2, 'id', this.form.category_id).label;
				}
				let character = this.characters.join(',');
				let params = {
					"member_id": this.form.member_id,
					"_id": '',
					"status": this.form.status,
					"nick_name": this.form.nick_name,
					"eprom_no": this.form.eprom_no,  // 芯片号
					"pet_type": this.form.pet_type,  
					"category_id": this.form.category_id,
					"category_name": category_name,  
					"pet_features": this.form.pet_features,  // 0: 不限制 1:短毛 2:长毛
					"pet_varieties": this.form.pet_varieties,  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
					"pet_certificate_no": this.form.pet_certificate_no,  // 宠物证件编号
					"character": character,  // 性格
					"pet_sex": this.form.pet_sex,  
					"pet_color": this.form.pet_color,  
					"remark": this.form.remark,  
					"hs_pet": this.form.hs_pet,  // 是否花生宠物
					"sterilization": 0,  // 绝育
					"immunization": 0,  // 免疫
					"bron_date": this.$public.FTime(new Date(this.form.bron_date).getTime(),'YYYY-MM-DD'),  // 生日
					"home_date": this.form.home_date,  // 到家时间
					"avatar_pic":this.form.avatar_pic,  // 缩略图
					"tool_num": this.form.tool_num,  // 用具编号
					"weight": this.form.weight?Number(this.form.weight):0, 
					"weight_remark": this.form.weight_remark,
				}
				let s = this.checkList.join(',');
				if (s.indexOf('已绝育') > -1) {
					params.sterilization = 1
				}
				if (s.indexOf('已免疫') > -1) {
					params.immunization = 1
				}
				console.log(params)
				let loading = this.$loading()
				if (this.dialog_type == 'addPet') {
					this.$http.post(process.env.VUE_APP_business+'/api/Pet/Insert', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '添加成功',
								type: 'success'
							});
							this.$emit('submit',{type:'success'})
						}
					})
				} else {
					params._id = this.form._id;
					this.$http.post(process.env.VUE_APP_business+'/api/Pet/Update', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.$emit('submit',{type:'success'})
						}
					})
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.drawer {
		::v-deep .el-drawer__body{
			overflow-y: auto;
			padding-bottom:30px;
			.el-form-item{
				margin-bottom: 8px;
			}
		}
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: #E6A23C;
			}
		}
	}
</style>
